import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { filter } from 'rxjs/operators';

export abstract class AbstractEventHasItemsStore {

  protected hasItemsByVendorCache: Map<number, BehaviorSubject<boolean>> = new Map();

  constructor() { }

  protected loadEventHasItemsCache(eventHasItemsByVendor: { [key: number]: boolean }): void {
    this.resetHasItemsByVendorCache();

    Object.keys(eventHasItemsByVendor).forEach(key => {
      const eventPartyIdKey = +key;
      const hasItems = eventHasItemsByVendor[eventPartyIdKey];

      this.upsertVendorHasItems(eventPartyIdKey, hasItems);
    });
  }

  private upsertVendorHasItems(eventPartyId: number, hasItems: boolean): void {
    let vendorHasItemsSubject = this.hasItemsByVendorCache.get(eventPartyId);
    if (!!vendorHasItemsSubject) {
      vendorHasItemsSubject.next(hasItems);
    } else {
      vendorHasItemsSubject = new BehaviorSubject<boolean>(hasItems);
      this.hasItemsByVendorCache.set(eventPartyId, vendorHasItemsSubject);
    }
  }

  private resetHasItemsByVendorCache(): void {
    this.hasItemsByVendorCache.forEach((vendorHasItemsSubject: BehaviorSubject<boolean>) => {
      vendorHasItemsSubject.complete();
    });
    this.hasItemsByVendorCache = new Map<number, BehaviorSubject<boolean>>();
  }

  protected getEventHasItems(): Observable<boolean> {
    const observables = Array.from(this.hasItemsByVendorCache.values());
    if (observables.length === 0) {
      return Observable.of(false);
    }

    return Observable.combineLatest(observables)
        .map(values => values.some(value => value === true));
  }

  protected getHasItemsByEventPartyId(eventPartyId: number): Observable<boolean> {
    if (!eventPartyId) {
      return Observable.of(false);
    }
    let vendorHasItemsSubject = this.hasItemsByVendorCache.get(eventPartyId);
    if (!vendorHasItemsSubject) {
      vendorHasItemsSubject = new BehaviorSubject<boolean>(null);
      this.hasItemsByVendorCache.set(eventPartyId, vendorHasItemsSubject);
    }
    return vendorHasItemsSubject.asObservable().pipe(
      filter(hasItems => hasItems != null)
    );
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/abstract-event-has-items.store.ts